import {
    Box,
    FormControl,
    Text,
    FormLabel,
    Grid,
    GridItem,
    Input,
    Stack,
    Select,
    SimpleGrid,
    Textarea,
    HStack,
    RadioGroup,
    Radio,
    CheckboxGroup,
    Checkbox,
    Button,
    Image,
    Icon,
    AspectRatio,
    Center,
    Spinner,
} from '@chakra-ui/react'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import AdminBlockCard from '../../components/AdminBlockCard'
import { TiDelete } from 'react-icons/ti'
import { useState, useEffect } from 'react'
import { FiSave, FiUpload } from 'react-icons/fi'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { CreatableSelect , Select as SearchableSelect} from 'chakra-react-select'
import { Controller, useForm } from 'react-hook-form'
import { getRequest, postRequest } from '../../services/base.service'
import { serialize } from 'object-to-formdata'
import { useToast } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
    setAdminSidebarFalseOnUrlChange,
    setCurrentPageHeading,
} from '../../redux/common/commonActions'
import { FaEdit } from "react-icons/fa";

const EditProductCategory = () => {

    const breadCrumb = [
        { label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
        {
            label: 'Product Category List',
            isCurrentPage: false,
            link: '/admin/product-category-list',
        },
        { label: 'Edit Product Category', isCurrentPage: true },
    ]

    const [isDataLoading, setIsDataLoading] = useState(true)
    const [fData, setFData] = useState(null)
    const {
            register,
            handleSubmit,
            setValue,
            control,
            watch,
            formState: { errors },
        } = useForm({
            defaultValues: {
                name: '',
            },
    })
    const [image, setImage] = useState(null)
    const [imageLink, setImageLink] = useState(null)
    const [productCategoryFormError, setProductCategoryFormError] = useState(null)
    const [isUpdating, setIsUpdating] = useState(false)
    const params = useParams()
    const dispatch = useDispatch()
    const [ImageFile, setImageFile] = useState(null)
    const toast = useToast()
    const navigate = useNavigate()

    useEffect(() => {
            const { id } = params
            fetchProductCategoryData(id)
            dispatch(setCurrentPageHeading('Edit Product Category'))
            dispatch(setAdminSidebarFalseOnUrlChange())
    }, [params])

    const fetchProductCategoryData = (id) => {
                getRequest(`admin/categories/${id}`)
                    .then((res) => {
                        if (res.result) {
                            // console.log('INDUSTRY DATA: ', res.result)
                            setFData(res.result)
                            setValue('name', res.result?.name)
                            setImageLink(res.result?.image)
                        }
                        setIsDataLoading(false)
                    })
                    .catch((err) => {
                        console.log('ERR: ', err)
                    })
    }

    const browseImage = (e) => {
		if (e.target.files.length > 0) {
			setImageFile(e.target.files[0])
			setImage(URL.createObjectURL(e.target.files[0]))
		}
	}

    const handleEditProductCategory = (data) => {
        setIsUpdating(true)
        // console.log("updated data: ", data)
        postRequest(
            `admin/categories/${params.id}`,
            objectToFormData({
                ...data,
                image: ImageFile,
                _method: 'PUT'
            })
        )
            .then((res) => {
                toast({
                    title: 'Saved Successfully',
                    description: res.message,
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                setIsUpdating(false)
                navigate(`/admin/product-category-list`)
            })
            .catch((err) => {
                console.log('ERR: ', err)
                toast({
                    title: 'Something Went Wrong!!!',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
                setProductCategoryFormError(err.response?.data?.errors)
                setIsUpdating(false)
            })
    }

    const objectToFormData = (data) => {
        const object = data
        const formData = serialize(object, { indices: true })
        return formData
    }

    return (
            <>
                <AdminBreadcrumb items={breadCrumb} />
                <Box py={7}>
                    <AdminBlockCard title={'Edit Product Category'}>
                        {isDataLoading ? (
                                            <Center>
                                                <Spinner color="red.500" size="xl" speed="0.6s" />
                                            </Center>
                        ) : (
                            <Box
                                pt={'5'}
                                pb={'8'}
                                as="form"
                                onSubmit={handleSubmit(handleEditProductCategory)}
                            >
                                <Grid
                                    templateColumns={[
                                        'repeat(1, 1fr)',
                                        'repeat(1, 1fr)',
                                        'repeat(1, 1fr)',
                                        'repeat(4, 1fr)',
                                    ]}
                                    mt={6}
                                    gap={6}
                                >
                                    <GridItem colSpan={3}>
                                        <Stack gap={2}>
                                            <FormControl>
                                                <FormLabel htmlFor="name">Product Category Name</FormLabel>
                                                    <Input
                                                        id="name"
                                                        type="text"
                                                        placeholder={'Enter product category name'}
                                                        borderColor={'gray.300'}
                                                        size={'lg'}
                                                        {...register('name', {
                                                            required: true,
                                                        })}
                                                    />     
                                                        <Text fontSize="sm" color="red.500">
                                                            {errors.name?.type === 'required' &&
                                                                'Product Category Name is required'}
                                                        </Text>
                                                        {productCategoryFormError?.name && (
                                                            <Text fontSize="sm" mt="2" color="red.500">
                                                                {productCategoryFormError?.name[0]}
                                                            </Text>
                                                        )}                                                                               
                                            </FormControl>
                                        </Stack>
                                    </GridItem>
                                    <GridItem>
                                                <Stack spacing={5}>
                                                    <FormControl>
                                                        <FormLabel>Product Category Image</FormLabel>
                                                        <Box
                                                            display={'block'}
                                                            as="label"
                                                            borderWidth={'1px'}
                                                            borderStyle={'1px'}
                                                            borderColor={'gray.400'}
                                                            htmlFor="browseImage"
                                                            pos={'relative'}
                                                            w={'160px'}
                                                            h={'160px'}
                                                            style={{
                                                                cursor: 'pointer',
                                                                '& > .label': {
                                                                    display: 'none',
                                                                },
                                                                '&:hover > .label': {
                                                                    display: 'block',
                                                                },
                                                            }}
                                                        >
                                                            {image || imageLink && (
                                                                <Image
                                                                    src={image ? image : imageLink}
                                                                    alt={''}
                                                                    w={'100%'}
                                                                    h={'100%'}
                                                                    objectFit={'contain'}
                                                                />
                                                            )}
                                                            <Input
                                                                name="image"
                                                                zIndex={'-99999'}
                                                                opacity={'0'}
                                                                type={'file'}
                                                                id={'browseImage'}
                                                                onChange={browseImage}
                                                                accept={'image/*'}
                                                                isRequired={!fData}
                                                            />
                                                            <Text
                                                                as="span"
                                                                className={'label'}
                                                                pos={'absolute'}
                                                                top={'50%'}
                                                                left={'50%'}
                                                                fontSize={'12px'}
                                                                display={'block'}
                                                                whiteSpace={'nowrap'}
                                                                px={'2'}
                                                                py={'1'}
                                                                rounded={'full'}
                                                                color={'white'}
                                                                bg={'blue.500'}
                                                                textAlign={'center'}
                                                                textTransform={'uppercase'}
                                                                transform={'translate(-50%, -50%)'}
                                                            >
                                                                Change Image
                                                            </Text>
                                                        </Box>
                                                    </FormControl>
                                                </Stack>
                                    </GridItem>
                                </Grid>
                                <Box textAlign={'left'} mt={'3'}>
                                    <Button
                                        isLoading={isUpdating}
                                        loadingText={'UPDATING...'}
                                        type={'submit'}
                                        size={'lg'}
                                        variant={'brand'}
                                        leftIcon={<FaEdit />}
                                    >
                                        UPDATE &nbsp;
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </AdminBlockCard>
                </Box>
            </>
    )
}

export default EditProductCategory